import React, { ReactNode } from 'react';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { Box, Button, CircularProgress } from '@mui/material';

interface TagFormHeaderProps {
  mode: 'create' | 'edit';
  isSaving: boolean;
  isSaveDisabled?: boolean;
  nameInput?: ReactNode;
  onViewContent?: () => void;
  onBack: () => void;
  onSave: () => void;
}

export default function TagFormHeader({
  mode,
  isSaving = false,
  isSaveDisabled = false,
  nameInput,
  onViewContent,
  onBack,
  onSave,
}: TagFormHeaderProps) {
  return (
    <Box mb={3} display="flex" alignItems="flex-start" gap={3}>
      <Box display="flex" alignItems="center" sx={{ minWidth: 160 }}>
        <Button variant="text" startIcon={<ArrowBackIcon />} onClick={onBack}>
          Back to List
        </Button>
      </Box>
      <Box flex={1} display="flex" justifyContent="center">
        <Box sx={{ width: '100%', maxWidth: 480 }}>{nameInput}</Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" alignItems="center" gap={2} sx={{ minWidth: 160 }}>
        {onViewContent && (
          <Button variant="text" onClick={onViewContent}>
            View content
          </Button>
        )}
        <Button
          variant="contained"
          startIcon={isSaving ? <CircularProgress size={20} /> : <SaveIcon />}
          onClick={onSave}
          disabled={isSaveDisabled || isSaving}
        >
          {mode === 'edit' ? 'Save changes' : 'Save'}
        </Button>
      </Box>
    </Box>
  );
}
